/**
 * Created by rathompson on 10/7/22
 * File: LoadingProvider
 * Project: MSP ©Palo Alto Networks
 * © Palo Alto Networks
 */

import { createContext, useState, useContext, VFC, Dispatch, SetStateAction } from 'react'

const _setLoading: Dispatch<SetStateAction<boolean>> = () => null
const LoadingContext = createContext({ loading: false, setLoading: _setLoading })

export const useLoadingContext: () => { loading: boolean, setLoading: Dispatch<SetStateAction<boolean>> } = () => useContext(LoadingContext)

const LoadingProvider: VFC<any> = ({ children }) => {

  const [loading, setLoading] = useState(false)

  return (
    <LoadingContext.Provider value={{ loading, setLoading }}>
      {children}
    </LoadingContext.Provider>
  )
}

export default LoadingProvider
